import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '@common/models';

export interface ITrustedApplicationModel extends IModel {
  trustedApplicationId: number;
  name: string;
  appId: string;
  appKey: string;
  appKey2: string;
  appKeyCreatedDate: string;
  appKey2CreatedDate: string;
}

export class TrustedApplicationModel
  extends Model
  implements ModelRecord<ITrustedApplicationModel>
{
  trustedApplicationId: number;
  name: string;
  appId: string;
  appKey: string;
  appKey2: string;
  appKeyCreatedDate: Date;
  appKey2CreatedDate: Date;

  constructor(params?: Partial<ITrustedApplicationModel>) {
    super(params);
    this.trustedApplicationId = defaultTo(params?.trustedApplicationId, 0);
    this.name = defaultTo(params?.name, '');
    this.appId = defaultTo(params?.appId, '');
    this.appKey = defaultTo(params?.appKey, '');
    this.appKey2 = defaultTo(params?.appKey2, '');
    this.appKeyCreatedDate = new Date(
      defaultTo(params?.appKeyCreatedDate, '2000-01-01'),
    );
    this.appKey2CreatedDate = new Date(
      defaultTo(params?.appKey2CreatedDate, '2000-01-01'),
    );
  }
}
